/* Reviews pillar: fetches the group's reviews and score from Okendo's storefront API (the same calls its own
   carousel makes), in the visitor's language, once the section comes near the screen. Built with textContent
   only, never innerHTML: the words are the customers' own, shown as Okendo returns them.
   Desktop: pairs that turn on their own like the trust pillar, and stop for good at the first touch.
   Phones: one review at a time, swiped, with the progress line and "1 / 10". */
(function () {
  if (window.__reviewsPillar) return;
  window.__reviewsPillar = true;
  var API = 'https://api.okendo.io/v1/stores/';
  var wide = window.matchMedia('(min-width: 768px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Okendo's own placeholder title when a customer leaves none: "5 Stars", "5 Stjärnor", "5 Sterne" */
  var DEFAULT_TITLE = /^\s*\d\s+\S+\s*$/;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function stars(rating, tpl, lang) {
    var s = el('span', 'rvp__stars'), f = el('span');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', fill(tpl, { rating: num(rating, lang) }));
    f.style.width = Math.max(0, Math.min(100, rating / 5 * 100)) + '%';
    s.appendChild(f);
    return s;
  }
  function num(v, lang) {
    try { return Number(v).toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { return Number(v).toFixed(1); }
  }
  function ago(iso, lang) {
    var d = (Date.now() - new Date(iso).getTime()) / 864e5;
    if (!isFinite(d)) return '';
    try {
      var f = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
      if (d < 7) return f.format(-Math.round(d), 'day');
      if (d < 30) return f.format(-Math.round(d / 7), 'week');
      if (d < 365) return f.format(-Math.round(d / 30.44), 'month');
      return f.format(-Math.round(d / 365.25), 'year');
    } catch (e) { return ''; }
  }
  function country(code, lang) {
    if (!code) return '';
    try { return new Intl.DisplayNames([lang], { type: 'region' }).of(code); } catch (e) { return ''; }
  }
  var QUOTE_MAX = 60; /* characters: two lines of the quote in a desktop column */
  /* No title of the customer's own: the first sentence of the review becomes the quote, word for word */
  function split(r) {
    var title = (r.title || '').trim(), body = (r.body || '').trim();
    if (title && !DEFAULT_TITLE.test(title)) return [title, body];
    var m = body.match(/^[\s\S]*?[.!?](?=\s|$)/);
    var first = m ? m[0] : body;
    return [first.trim(), body.slice(first.length).trim()];
  }

  /* "✓ Verified buyer" at the end of the product line (Marcus 2026-11-03, option D), only when Okendo marks the reviewer */
  function verifiedMark(cls, label) {
    var s = el('span', cls), NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'), p = document.createElementNS(NS, 'path');
    svg.setAttribute('width', '11'); svg.setAttribute('height', '11'); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2.6'); svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round'); svg.setAttribute('aria-hidden', 'true');
    p.setAttribute('d', 'M5.5 12.5l4.2 4 8.8-9.5'); svg.appendChild(p); s.appendChild(svg); s.appendChild(document.createTextNode(label)); return s;
  }

  function card(r, sec, lang) {
    var parts = split(r), root = sec.getAttribute('data-root') || '';
    var a = el('article', 'rvp__card');
    var sTpl = sec.querySelector('.rvp__agg .rvp__stars');
    a.appendChild(stars(r.rating, sTpl && sTpl.getAttribute('data-tpl'), lang));
    a.appendChild(el('p', 'rvp__t', '“' + parts[0] + '”'));
    if (parts[1]) a.appendChild(el('p', 'rvp__b', parts[1]));
    else a.appendChild(el('p', 'rvp__b'));
    a.appendChild(el('span', 'rvp__rule'));
    var who = el('div', 'rvp__who');
    var name = (r.productName || '').split(' – ')[0];
    var href = r.productHandle ? root + '/products/' + r.productHandle : '';
    if (r.productImageUrl && href) {
      var pic = el('a', 'rvp__pic');
      pic.href = href;
      pic.tabIndex = -1;
      pic.setAttribute('aria-hidden', 'true');
      var img = el('img');
      img.src = r.productImageUrl;
      img.alt = '';
      img.width = 56; img.height = 70; img.loading = 'lazy'; img.decoding = 'async';
      pic.appendChild(img);
      who.appendChild(pic);
    }
    var words = el('div');
    var rv = r.reviewer || {};
    var tag = country(rv.location && rv.location.country && rv.location.country.code, lang);
    words.appendChild(el('p', 'rvp__name', (rv.displayName || '') + (tag ? ' · ' + tag : '')));
    var meta = el('p', 'rvp__meta');
    if (name && href) { var l = el('a', 'rvp__prod', name); l.href = href; meta.appendChild(l); }
    else if (name) meta.appendChild(document.createTextNode(name));
    var when = ago(r.dateCreated, lang);
    if (when) meta.appendChild(document.createTextNode((name ? ' · ' : '') + when));
    if (rv.isVerified) { meta.appendChild(document.createTextNode(' · ')); meta.appendChild(verifiedMark('rvp__ok', sec.getAttribute('data-verified'))); }
    words.appendChild(meta);
    who.appendChild(words);
    a.appendChild(who);
    return a;
  }

  /* Titles are always shown whole (Marcus 2026-11-03); only the review text fades past its lines. On desktop the
     parts line up by CSS subgrid, so nothing here measures the pair. */
  function fade(sec) {
    sec.querySelectorAll('.rvp__b').forEach(function (p) {
      p.classList.remove('is-faded');
      p.classList.toggle('is-faded', p.scrollHeight > p.clientHeight + 1);
    });
  }

  function load(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var list = sec.querySelector('[data-rvp-list]'), track = sec.querySelector('[data-rvp-track]');
    if (!list || !track) return;
    var lang = sec.getAttribute('data-locale') || document.documentElement.lang || 'en';
    var base = API + encodeURIComponent(sec.getAttribute('data-store')) + '/collections/' + encodeURIComponent(sec.getAttribute('data-group')) + '/';
    var n = +list.getAttribute('data-count') || 10;
    var q = 'locale=' + encodeURIComponent(lang);
    Promise.all([
      fetch(base + 'reviews?limit=' + Math.min(25, n * 2) + '&orderBy=date+desc&' + q).then(function (r) { if (!r.ok) throw r.status; return r.json(); }),
      fetch(base + 'review_aggregate?' + q).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      /* The parts line up across every review (one row each, Marcus 2026-11-03), so one four-line quote would hold
         four lines of space in all of them. The band picks reviews whose quote fits in two lines; nothing is cut, and
         the longer ones stay on the reviews page. Twice the count is fetched so the band stays full. */
      var reviews = (res[0] && res[0].reviews || []).filter(function (r) { return r && r.body && split(r)[0].length <= QUOTE_MAX; }).slice(0, n);
      if (!reviews.length) { sec.hidden = true; return; }
      score(sec, res[1] && res[1].reviewAggregate, lang);
      reviews.forEach(function (r) { track.appendChild(card(r, sec, lang)); });
      fade(sec);
      if ('ResizeObserver' in window) new ResizeObserver(function () { fade(sec); }).observe(track);
      turn(sec, list, track);
    }).catch(function () { sec.hidden = true; });
  }

  function score(sec, agg, lang) {
    /* Served in the HTML from the models' own numbers (Marcus 2026-11-03): use those, never Okendo's group total,
       so the page shows one figure to crawlers and to people. */
    var served = sec.querySelector('[data-rvp-agg][data-rvp-server]');
    if (served) {
      var h = sec.querySelector('[data-rvp-h2]');
      if (h && h.getAttribute('data-tpl')) h.textContent = fill(h.getAttribute('data-tpl'), { rating: served.getAttribute('data-rating'), count: served.getAttribute('data-count') });
      return;
    }
    if (!agg || !agg.reviewCount) return;
    var rating = agg.reviewRatingValuesTotal / agg.reviewCount, count = agg.reviewCount.toLocaleString(lang);
    var h2 = sec.querySelector('[data-rvp-h2]');
    if (h2 && h2.getAttribute('data-tpl')) h2.textContent = fill(h2.getAttribute('data-tpl'), { rating: num(rating, lang), count: count });
    var box = sec.querySelector('[data-rvp-agg]');
    if (!box) return;
    var s = box.querySelector('.rvp__stars');
    s.setAttribute('aria-label', fill(s.getAttribute('data-tpl'), { rating: num(rating, lang) }));
    s.firstElementChild.style.width = Math.min(100, rating / 5 * 100) + '%';
    var c = box.querySelector('[data-rvp-count]');
    c.textContent = fill(c.getAttribute('data-tpl'), { count: count });
    box.hidden = false;
  }

  /* Desktop: pages of two, dots, autoplay. Phones: swipe, progress line. */
  function turn(sec, list, track) {
    var cards = [].slice.call(track.children), dotsEl = list.querySelector('[data-rvp-dots]');
    var fillEl = list.querySelector('[data-rvp-fill]'), nEl = list.querySelector('[data-rvp-n]');
    var secs = +list.getAttribute('data-autoplay') || 0, i = 0, timer = null, stopped = false, seen = false;
    function per() { return wide.matches ? 2 : 1; }
    function pages() { return Math.ceil(cards.length / per()); }
    function build() {
      dotsEl.textContent = '';
      for (var p = 0; p < pages(); p++) {
        var b = el('button');
        b.type = 'button';
        b.setAttribute('aria-label', fill(dotsEl.getAttribute('data-tpl'), { n: p + 1, total: pages() }));
        b.addEventListener('click', (function (k) { return function () { stop(); go(k); }; })(p));
        dotsEl.appendChild(b);
      }
      mark();
    }
    function mark() {
      [].forEach.call(dotsEl.children, function (d, k) { d.setAttribute('aria-current', String(k === i)); });
      var t = pages();
      if (fillEl) { fillEl.style.width = (100 / t) + '%'; fillEl.style.left = (i * 100 / t) + '%'; }
      if (nEl) nEl.textContent = (i + 1) + ' / ' + t;
    }
    /* Seamless loop (Marcus 2026-11-03): copies of the first two reviews sit after the last. Past the last dot the
       track glides on to the copies and then lands, unseen, on the real first, instead of rewinding through them all.
       The copies are hidden from screen readers and take no focus or taps. */
    var clones = cards.slice(0, 2).map(function (c) {
      var k = c.cloneNode(true);
      k.classList.add('is-clone');
      k.setAttribute('aria-hidden', 'true');
      k.inert = true;
      track.appendChild(k);
      return k;
    });
    var busy = false, settle = null;
    function at(k) { var c = k < cards.length ? cards[k] : clones[k - cards.length]; return c.offsetLeft - track.offsetLeft; }
    function end() { return at(cards.length); }
    function jump(x) { track.style.scrollSnapType = 'none'; track.scrollLeft = x; requestAnimationFrame(function () { track.style.scrollSnapType = ''; }); }
    /* A calm glide (ease in-out, 700 ms) instead of the browser's quick smooth scroll */
    function glide(to, done) {
      if (still.matches) { jump(to); if (done) done(); return; }
      var from = track.scrollLeft, t0 = null;
      busy = true;
      track.style.scrollSnapType = 'none';
      requestAnimationFrame(function frame(t) {
        if (t0 === null) t0 = t;
        var q = Math.min(1, (t - t0) / 700), e = q < .5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2;
        track.scrollLeft = from + (to - from) * e;
        if (q < 1) return requestAnimationFrame(frame);
        track.style.scrollSnapType = '';
        busy = false;
        if (done) done();
      });
    }
    function go(p) {
      var wrap = i === pages() - 1 && p === pages();
      i = (p + pages()) % pages();
      mark();
      if (wrap) glide(end(), function () { jump(at(0)); });
      else glide(at(i * per()));
    }
    track.addEventListener('scroll', function () {
      if (busy) return;
      var w = Math.max(1, (at(1) - at(0)) * per());
      var p = Math.round(track.scrollLeft / w) % pages();
      if (p !== i) { i = p; mark(); }
      /* A swipe that ends on the copies lands on the real first */
      clearTimeout(settle);
      settle = setTimeout(function () { if (!busy && track.scrollLeft >= end() - 2) jump(track.scrollLeft - end() + at(0)); }, 140);
    }, { passive: true });
    function stop() { stopped = true; clearInterval(timer); timer = null; }
    ['pointerdown', 'touchstart', 'keydown', 'focusin', 'wheel'].forEach(function (t) { list.addEventListener(t, stop, { passive: true }); });
    function run() {
      clearInterval(timer); timer = null;
      if (stopped || !secs || !wide.matches || still.matches || !seen || document.hidden || pages() < 2) return;
      timer = setInterval(function () { go(i + 1); }, secs * 1000);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; run(); }, { threshold: .5 }).observe(track);
    }
    document.addEventListener('visibilitychange', run);
    if (wide.addEventListener) wide.addEventListener('change', function () { i = 0; build(); jump(0); run(); });
    build();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-rvp]').forEach(function (sec) {
      if (!('IntersectionObserver' in window)) { load(sec); return; }
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); load(sec); }
      }, { rootMargin: '800px 0px' });
      io.observe(sec);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
